import React from "react";

import InactiveUser from "../InactiveUser/InactiveUser";
import ActiveUser from "../ActiveUser/ActiveUser";

export default function Loginsession(props) {
  const userdata = props.logedinuser;
  return (
    <div className="prophet">
      {userdata.userStatus === "inactive" ? (
        <div>
          <InactiveUser logedinuser={userdata} />
        </div>
      ) : (
        <ActiveUser logedinuser={userdata} />
      )}
    </div>
  );
}
